<div class="number-counter-wrapper" *ngIf="customOptions">
    <div class="d-flex border">
        <div class="btnAction minus {{counter == customOptions.min ? 'disabled': ''}}" *ngIf="!viewOnly"
            (click)="minus()">
            <mat-icon>remove</mat-icon>
        </div>

        <input class="flex-grow-1" type="number" min="{{customOptions.min}}" max="{{customOptions.max}}"
            [readonly]="!customOptions.enableUserEntry" [disabled]="viewOnly" (keyup)="changeValue()"
            [(ngModel)]="counter" />

        <div class="btnAction add {{counter == customOptions.max ? 'disabled': ''}}" *ngIf="!viewOnly" (click)="add()">
            <mat-icon>add</mat-icon>
        </div>
    </div>
</div>